<template>
  <div class="acomodar">
    <div class="container-fluid py-3 px-2 px-md-4 ">

      <button class="btn btn-danger mt-2 ms-2 mb-2" @click="retrocedo">
        <i class="bi bi-skip-backward"></i>
      </button>

      <button @click="activador" class="btn btn-success ms-2 mt-2 mb-2"
        v-if="permisoVisualizador == 2 || permisoVisualizador == 18" title="EDITAR DATOS DEL POSTULANTE">
        <i class="bi bi-pencil-square"></i>
      </button>

      <button v-if="permisoVisualizador == 2 || permisoVisualizador == 18" @click="apagar = !apagar"
        title="EDITAR BANCOS DEL POSTULANTE" class="btn btn-success mt-2 text-white ms-2 mb-2">
        <i class="bi bi-bank2"></i>
      </button>

      <button v-if="permisoVisualizador == 11 && guar.modIngreso == false"
        class="btn btn-warning mt-2 text-white ms-2 mb-2" title="EDITAR BANCOS DEL POSTULANTE"
        @click="apagar = !apagar">
        <i class="bi bi-bank2"></i>
      </button>

      <button v-if="permisoVisualizador != 11" class="btn btn-success ms-2 mt-2 text-white mb-2">
        <i class="bi bi-file-pdf"></i>
      </button>

      <!-- <button
          v-if="permisoVisualizador == 11 && this.form.modPostulante == false"
          @click="activador"
          class="btn btn-white"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            fill="currentColor"
            class="bi bi-pencil-square text-primary"
            viewBox="0 0 16 16"
          >
            <path
              d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
            />
            <path
              fill-rule="evenodd"
              d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
            />
          </svg>
        </button> -->

      <div class="border border-1 rounded-3 p-3 mb-3 ">
        <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
          <i class="bi bi-person-vcard display-4 text-primary"></i>
          <div>
            <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
              ETAPA DE SELECCION
            </p>
            <p class="mb-0 tituloResaltado fs-4 fw-bold">
              DATOS DE LA SOLICITUD
            </p>
          </div>
        </div>
      </div>


      <form action="" @submit.prevent="modificaPostulante">
        <div class="border border-1 rounded-3 p-3 mb-3 ">

          <div class="d-flex">

            <div class="row gx-3 gy-2">

            <div class="col-12">  
               <div class="me-md-4">
                <label for="imageUpload"
                      class="image-upload-circle large d-flex justify-content-center align-items-center mx-auto position-relative"
                      :style="isdisabled ? 'pointer-events: none; opacity: 0.8;' : 'cursor: pointer;'">
                  <div v-if="loadingImagen" class="spinner-border text-success" role="status"></div>
                  <template v-else>
                    <span v-if="(form.PosImagen == '1' || !form.PosImagen) && !previewUrl" class="upload-text">Subir foto</span>
                    <img v-else :src="previewUrl || (typeof form.PosImagen === 'string' ? url + form.PosImagen.split('\\').pop() : '')" alt="Foto Postulante" />
                  </template>
                </label>
                <input :disabled="isdisabled" type="file" id="imageUpload" accept="image/*" style="display: none;" @change="handleImageUpload" />
                                <br>

                <p  class="tamaño ">La fotografía debe ser tipo carnet, reciente, con fondo blanco, buena iluminación y vestimenta formal.<br>
                El rostro debe ser claramente visible.
                </p>

                 <select :disabled="isdisabled"  class="form-select tamaños mt-1" aria-label="Default select example" @change="form.posPolo = $event.target.value">
                <option class="text-center" disabled selected> {{ desPolo ? desPolo : '-- POLO --' }}</option>
                <option v-for="polo in polos" :key="polo.id" :value="polo.parCorrelativo">
                  {{ polo.parDescripcion }}
                </option>
              </select>

               <select :disabled="isdisabled"  class="form-select tamaños mt-1" aria-label="Default select example" @change="form.posPantalon = $event.target.value">
                <option class="text-center" disabled selected>{{ desPantalon ? desPantalon : '-- PANTALON --' }}</option>
                <option v-for="panta in pantalon" :key="panta.id" :value="panta.parCorrelativo">
                  {{ panta.parDescripcion }}
                </option>
              </select>

               <select :disabled="isdisabled"  class="form-select tamaños mt-1" aria-label="Default select example" @change="form.posZapatos = $event.target.value">
                <option class="text-center" disabled selected> {{ desCalzado ? desCalzado : '-- CALZADO --' }}</option>
                <option v-for="zapato in zapatos" :key="zapato.id" :value="zapato.parCorrelativo">
                  {{ zapato.parDescripcion }}
                </option>
              </select>
              </div>    

                           
          
             
          </div>
              </div>


          <div class="row gx-3 gy-2">
                      <div class="col-lg-2 col-md-6">
              <label class="tamaño d-flex align-items-center gap-1">
                <i class="bi bi-person fs-6 text-warning me-2"></i> APELLIDO PATERNO:
              </label>
              <input :disabled="isdisabled" type="text" class="form-control tamaños" v-model.trim="form.posApePaterno"
                aria-describedby="emailHelp" />
            </div>

            <div class="col-lg-2 col-md-6">
              <label class="tamaño d-flex align-items-center gap-1">
                <i class="bi bi-person fs-6 text-primary me-2"></i> APELLIDO MATERNO:
              </label>
              <input :disabled="isdisabled" type="text" class="form-control tamaños" v-model.trim="form.posApeMaterno"
                aria-describedby="emailHelp" />
            </div>

            <div class="col-lg-2 col-md-6">
              <label class="tamaño d-flex align-items-center gap-1">
                <i class="bi bi-person-badge fs-6 text-warning me-2"></i> NOMBRES:
              </label>
              <input :disabled="isdisabled" type="text" class="form-control tamaños" v-model.trim="form.posNombre"
                aria-describedby="emailHelp" />
            </div>
            <div class="col-lg-2 col-md-6">
              <label class="tamaño d-flex align-items-center gap-1">
                <i class="bi bi-file-earmark-text fs-6 text-info me-2"></i> TIPO DOCUMENTO:
              </label>
              <input :disabled="isdisabled" v-if="muestra" type="text" class="form-control tamaños" v-model.trim="desDocumento"
                v-model="desDocumento" aria-describedby="emailHelp" />

              <select v-else class="form-select tamaños" aria-label="Default select example"
                @change="Documentos($event)">
                <option disabled selected>{{ desDocumento }}</option>
                <option v-for="documen in Arreglar" :key="documen.id" :value="documen.parCorrelativo">
                  {{ documen.parDescripcion }}
                </option>
              </select>
            </div>
            <div class="col-lg-2 col-md-6">
              <label class="tamaño d-flex align-items-center gap-1">
                <i class="bi bi-credit-card fs-6 text-primary me-2"></i> N° DOCUMENTO:
              </label> 
              <input :disabled="isdisabled" type="text" class="form-control tamaños" v-model.trim="form.posNroDocumento"
                aria-describedby="emailHelp" />
            </div>

           <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-gender-ambiguous fs-6  me-2"></i> GENERO:
            </label>
              <input v-if="muestra" :disabled="isdisabled" type="text" class="form-control tamaños" :value="nomGenero || '-- SELECCIONAR GÉNERO --'"
                aria-describedby="emailHelp" />

              <select v-else class="form-select tamaños" aria-label="Default select example" @change="Generos($event)">
                <option disabled selected>{{ nomGenero || '-- SELECCIONAR GÉNERO --' }}</option>
                <option v-for="gen in Genero" :key="gen.id" :value="gen.parCorrelativo">
                  {{ gen.parDescripcion }}
                </option>
              </select>
            </div>

          <div class="col-lg-4 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-envelope fs-6 text-primary me-2"></i> CORREO ELECTRONICO:
            </label>
              <input :disabled="isdisabled" type="text" class="form-control tamaños" v-model.trim="form.posCorreo"
                aria-describedby="emailHelp" />
            </div>

             <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-people fs-6 text-warning me-2"></i> ESTADO CIVIL:
            </label>
              <input :disabled="isdisabled" v-if="muestra" type="text" class="form-control tamaños" :value="nomEstadoCivil || '-- SELECCIONAR ESTADO CIVIL --'"  aria-describedby="emailHelp" />

              <select v-else class="form-select tamaños" aria-label="Default select example" @change="estado($event)">
                <option disabled selected>{{ nomEstadoCivil || '-- SELECCIONAR ESTADO CIVIL --'}}</option>
                <option v-for="estado in EstadoCiviles" :key="estado.id" :value="estado.parCorrelativo">
                  {{ estado.parDescripcion }}
                </option>
              </select>
            </div>

            <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-telephone fs-6 text-success me-2"></i> TELEFONO:
            </label>
              <input :disabled="isdisabled" type="text" class="form-control tamaños" v-model.trim="form.posTelefono"
                aria-describedby="emailHelp" />
            </div>

             <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-phone fs-6 text-success me-2"></i> TELEF. ADICIONAL:
            </label>
              <input :disabled="isdisabled" type="text" class="form-control tamaños" v-model.trim="form.posTelAdicional"
                aria-describedby="emailHelp" />
            </div>

            <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-cake fs-6 text-danger me-2"></i> FECH. NACIMIENTO:
            </label>
              <input :disabled="isdisabled" type="text" class="form-control tamaños" v-model.trim="form.posFecNacimiento"
                aria-describedby="emailHelp" />
            </div>

            <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-people-fill fs-6 text-info me-2"></i> CANT HIJOS:
            </label>
              <input :disabled="isdisabled" type="number" class="form-control tamaños" v-model="form.posCanHijos"
                aria-describedby="emailHelp" min="0" max="9" />
            </div>

             <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-person-standing fs-6 text-dark me-2"></i> {{ menor }} 18 AÑOS:
            </label>
              <input :disabled="isdisabled" type="number" class="form-control tamaños" aria-describedby="emailHelp"
                v-model="form.posHijosMen" min="0" max="9" />
            </div>

            <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-geo-alt fs-6 text-danger me-2"></i> PAIS:
            </label>
              <input :disabled="isdisabled" v-if="muestra" type="text" class="form-control tamaños" v-model.trim="nomPais"
                aria-describedby="emailHelp" v-model="nomPais" />

              <select v-else class="form-select tamaños" aria-label="Default select example tamaños"
                @change="PaisDes($event)">
                <option disabled selected>{{ nomPais }}</option>
                <option v-for="paisDes in PaisEstado" :key="paisDes.id" :value="paisDes.parCorrelativo">
                  {{ paisDes.parDescripcion }}
                </option>
              </select>
            </div>

             <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-flag fs-6 text-danger me-2"></i> NACIONALIDAD:
            </label>
              <input :disabled="isdisabled" type="text" v-if="muestra" class="form-control tamaños" v-model.trim="nomNacionalidad"
                aria-describedby="emailHelp" v-model="nomNacionalidad" />
              <select v-else class="form-select tamaños" aria-label="Default select example" @change="Nacion($event)">
                <option disabled selected>{{ nomNacionalidad }}</option>
                <option v-for="nacion in NacionEstado" :key="nacion.id" :value="nacion.parCorrelativo">
                  {{ nacion.parDescripcion }}
                </option>
              </select>
            </div>

            <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-map fs-6 text-info me-2"></i> DEPARTAMENTO:
            </label>
              <input v-if="muestra" :disabled="isdisabled" type="text" class="form-control tamaños" v-model.trim="ubiDepartamento"
                aria-describedby="emailHelp" v-model="ubiDepartamento" />

              <select v-else class="form-select tamaños" aria-label="Default select example"
                @change="Departamen($event)">
                <option disabled selected>{{ ubiDepartamento }}</option>
                <option v-for="depa in DepartamentoDistrito" :key="depa.id" :value="depa.idParametro">
                  {{ depa.parDescripcion }}
                </option>
              </select>
            </div>

            <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-pin-map fs-6 text-warning me-2"></i> PROVINCIA:
            </label>
              <input :disabled="isdisabled" v-if="muestra" type="text" class="form-control tamaños" v-model.trim="ubiProvincia"
                aria-describedby="emailHelp" v-model="ubiProvincia" />

              <select v-else class="form-select tamaños" aria-label="Default select example" @change="Province($event)">
                <option disabled selected>{{ ubiDepartamento }}</option>
                <option v-for="prov in provincia" :key="prov.id" :value="prov.idParametro">
                  {{ prov.parDescripcion }}
                </option>
              </select>
            </div>

             <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-pin-map-fill fs-6 text-danger me-2"></i> DISTRITO:
            </label> 
              <input :disabled="isdisabled" type="text" v-if="muestra" class="form-control tamaños" v-model.trim="ubiDistrito"
                aria-describedby="emailHelp" v-model="ubiDistrito" />

              <select v-else class="form-select tamaños" aria-label="Default select example" @change="Distrito($event)">
                <option disabled selected>{{ ubiDistrito }}</option>
                <option v-for="dist in distrito" :key="dist.id" :value="dist.parCorrelativo">
                  {{ dist.parDescripcion }}
                </option>
              </select>
            </div>

            <!-- <div class="col-lg-2 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-person-workspace fs-6 text- me-2"></i> PERFIL PROFESIONAL:
            </label>
              <input :disabled="isdisabled" type="text" class="form-control tamaños" v-model="form.posPerProfesional" />
            </div>

             <div class="form-group col-lg-3 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-mortarboard fs-6 text-info me-2"></i> ESTUDIOS SUPERIORES:
            </label>
              <input :disabled="isdisabled" type="text" class="form-control tamaños" v-model="form.posEstudios"
                id="exampleFormControlInput1" />
            </div> -->

             <div class="col-lg-4 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-award fs-6 text-warning me-2"></i> GRADO ACADEMICO:
            </label>
              <input v-if="muestra" :disabled="isdisabled" type="text" class="form-control tamaños" 
                aria-describedby="emailHelp" :value="desGradoAcademico || '-- SELECCIONAR GRADO ACADEMICO--'" />

              <select v-else class="form-select tamaños" aria-label="Default select example" @change="Grado($event)">
                <option disabled selected>{{ desGradoAcademico || '-- SELECCIONAR GRADO ACADEMICO--' }}</option>
                <option v-for="grado in gradoAcademico" :key="grado.id" :value="grado.parCorrelativo">
                  {{ grado.parDescripcion }}
                </option>
              </select>
            </div>

            <!--  -->
<!-- 
             <div class="form-group col-lg-3 col-md-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-briefcase fs-6 text-danger me-2"></i> OCUPACION:
            </label>
              <input :disabled="isdisabled" type="text" class="form-control tamaños" v-model="form.posOcupacion"
                id="exampleFormControlInput1" />
            </div> -->

           <div class="form-group col-lg-6 col-md-12">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-house-door fs-6 text-primary me-2"></i> DIRECCION:
            </label> 
              <input :disabled="isdisabled" type="text" class="form-control tamaños" v-model.trim="form.posDireccion"
                id="exampleFormControlInput1" />
            </div>

            <div class="form-group col-lg-4 col-sm-6">
              <input type="file" class="form-control mt-4 tamaños" id="inputGroupFile04"
                aria-describedby="inputGroupFileAddon04" aria-label="Upload" @change="onFileSelected" />
            </div>

             <div class="col col-lg-2 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-cash-stack fs-6 text-success me-2"></i> ¿TIENES RENTA QUINTA?
            </label>
              <div class="form-group d-flex align-items-end">
                <div class="form-check">
                  <input :disabled="isdisabled" class="form-check-input" type="checkbox"
                    v-model="form.posRentaQuinta" />

                </div>
              </div>


            </div>

            <div class="col col-lg-11 col-sm-6 my-auto">
              <div class="d-flex my-0 mt-3">
                <a v-if="form.posAdjunto != 1" :href="url + form.posAdjunto.slice(45, form.posAdjunto.length)
                  " target="_blank" class="btn btn-info my-0">
                  <i class="bi bi-cloud-download text-white fs-5"></i>
                </a>

                <p class="my-2 ms-2 mb-0 pb-0 tamaños" v-if="form.posAdjunto != 1">
                  {{ adjuntoNombre }}
                </p>
                <p class="my-2 ms-2 mb-0 pb-0 tamaños" v-if="form.posAdjunto != 1 && adjuntoNombre == ''">
                  {{ form.posAdjunto.slice(45) }}
                  <!-- {{form.posAdjunto}} -->
                </p>
              </div>



            </div>


            <div class="col col-lg-1 col-sm-1 d-flex justify-content-end mt-1">
              <button v-if="permisoVisualizador == 2 || permisoVisualizador == 18" @click="modificaPostulante"
                class="btn btn-success mb-0 px-3 py-2 my-auto">
                <i class="bi bi-floppy fs-5"></i>
              </button>

              <!-- <button
            v-if="permisoVisualizador == 11 && this.form.modPostulante == false"
            @click="modificaPostulante"
            class="btn btn-success mx-2 mb-3 px-5 py-3"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              fill="currentColor"
              class="bi bi-save2 mx-2"
              viewBox="0 0 16 16"
            >
              <path
                d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v4.5h2a.5.5 0 0 1 .354.854l-2.5 2.5a.5.5 0 0 1-.708 0l-2.5-2.5A.5.5 0 0 1 5.5 6.5h2V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1H2z"
              />
            </svg>
            GRABAR
          </button> -->
            </div>



            <p v-if="form.posAdjunto != 1" class="text-danger texto mx-2">
              (Solo se admite formatos pdf, jpg, jpeg, xlsx, docx, txt)
            </p>

            <p v-else class="text-danger texto">
              (Solo se admite formatos pdf, jpg, jpeg, xlsx, docx, txt)
            </p>

            <!--  -->

            <p class="col col-12 px-2 mt-2 texto">
              (*) Si tiene hijos menores a 18 años de edad, contará con un
              beneficio social de S/.113 , en el caso de contar con hijos
              menores a 24 años cursando estudios comunicarse con su supervisor
              o personal de selección.
            </p>
          </div>


          </div>
   

  
        </div>
      </form>

      <form action="" @submit.prevent="cambiarBancos">
          <div class="border border-1 rounded-3 p-3 mb-3 ">
          <div v-if="apagar" class="row gx-2 gy-2">

           <div class="col col-lg-3 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-cash fs-6 text-info me-2"></i> BANCO HABERES:</label> 
              <input disabled type="text" class="form-control tamaños"
                aria-describedby="emailHelp" :value="bancoHaberes || '-- SELECCIONAR BANCO HABERES --'" />
            </div>

             <div class="col col-lg-3 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-coin fs-6 text-success me-2"></i> MONEDA (HAB.):</label> 
              <input disabled type="text" class="form-control tamaños"
                id="exampleInputEmail1" aria-describedby="emailHelp"
                :value="monHaberes || '-- SELECCIONAR MONEDA HABERES --'" />
            </div>

            <div class="col col-lg-3 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-cash-stack fs-6 text-danger me-2"></i> BANCO DE CTS:</label> 
              <input disabled type="text" class="form-control tamaños"
                id="exampleInputEmail1" aria-describedby="emailHelp"
                :value="bancoCts || '-- SELECCIONAR BANCO CTS --'" />
            </div>

              <div class="col col-lg-3 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-coin text-warning fs-6 me-2"></i> MONEDA(CTS):</label> 
              <input disabled type="text" class="form-control tamaños"
                id="exampleInputEmail1" aria-describedby="emailHelp"
                :value="monCts || '-- SELECCIONAR MONEDA CTS --'" />
            </div>

           <div class="col col-lg-3 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-wallet2 fs-6 text-danger me-2"></i> SISTEMA DE PENSIONES:</label> 
              <input disabled type="text" class="form-control tamaños"
                id="exampleInputEmail1" aria-describedby="emailHelp"
                :value="NombresisPensiones === '' ? '-- SELECCIONAR SISTEMA PENSIONES --' : NombresisPensiones" />
            </div>

            <div class="col col-lg-3 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-telephone fs-6 text-info me-2"></i>
              CONTACTO DE EMERGENCIA:</label> 
              <input disabled type="text" class="form-control tamaños"
                id="exampleInputEmail1" aria-describedby="emailHelp" :value="guar.contacto || '-- SIN CONTACTO --'" />
            </div>

            <div class="col col-lg-3 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-phone fs-6 text-primary me-2"></i> N° DE CELULAR:</label> 
              <input disabled type="text" class="form-control tamaños"
                aria-describedby="emailHelp" :value="guar.celular || '-- SIN CELULAR --'" />
            </div>

            <div class="col-lg-1 col-md-6 d-flex justify-content-end mt-4 ms-2">
              <button v-if="permisoVisualizador == 2 || permisoVisualizador == 18" type="submit"
                class="btn btn-success mb-3 pe-3 py-1">
                <i class="bi bi-floppy fs-5"></i>
              </button>

              <!-- <button v-if="permisoVisualizador == 2 || permisoVisualizador == 18" type="submit"
                class="btn btn-success mb-3 pe-3 py-1 ms-2" @click="refrescarBancos">
                <i class="bi bi-box-arrow-in-up-left"></i>
              </button> -->
              <button v-if="permisoVisualizador == 11 && guar.modIngreso == false" type="submit"
                class="btn btn-success px-4 py-0 mt-1 ms-2" :class="{ 'w-100': !isMobile, 'w-25': isMobile }">
                <i class="bi bi-floppy fs-5"></i>
              </button>
            </div>
          </div>

          <div v-if="!apagar" class="row gx-2 gy-2">

             <div class="col col-lg-3 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-cash fs-6 text-info me-2"></i> BANCO HABERES:</label>
              <div>
                <select class="form-select tamaños" aria-label="Default select example" @change="bancoHab($event)">
                  <option disabled selected>{{ bancoHaberes || 'SELECCIONAR BANCO HABERES'}}</option>
                  <option v-for="banco in bancoHaber" :key="banco.id" :value="banco.parCorrelativo">
                    {{ banco.parDescripcion }}
                  </option>
                </select>
              </div>
            </div>

             <div class="col col-lg-3 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-coin fs-6 text-success me-2"></i> MONEDA (HAB.):</label>
              <div>
                <select class="form-select tamaños" aria-label="Default select example" @change="moneda1($event)">
                  <option disabled selected>{{ monHaberes || 'SELECCIONAR MONEDA' }}</option>
                  <option v-for="mone in moneda" :key="mone.id" :value="mone.parCorrelativo">
                    {{ mone.parDescripcion }}
                  </option>
                </select>
              </div>
            </div>

             <div class="col col-lg-3 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-cash-stack fs-6 text-danger me-2"></i> BANCO DE CTS:</label>
              <div>
                <select class="form-select tamaños" aria-label="Default select example" @change="bancoCts1($event)">
                  <option disabled selected>{{ bancoCts || 'SELECCIONAR BANCO' }}</option>
                  <option v-for="banco in banCts" :key="banco.id" :value="banco.parCorrelativo">
                    {{ banco.parDescripcion }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-lg-2 col-md-6">
              <label class="tamaño">Moneda(CTS):</label>
              <div>
                <select class="form-select tamaños" aria-label="Default select example" @change="monedaCts1($event)">
                  <option disabled selected>{{ monCts || 'SELECCIONAR MONEDA' }}</option>
                  <option v-for="mone in moneda" :key="mone.id" :value="mone.parCorrelativo">
                    {{ mone.parDescripcion }}
                  </option>
                </select>
              </div>
            </div>
           <div class="col col-lg-3 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-coin text-warning fs-6 me-2"></i> Sistema Pensiones:</label>
              <div>
                <select class="form-select tamaños" aria-label="Default select example" @change="pensiones1($event)">
                  <option selected disabled>{{ NombresisPensiones === '' ? '-- SELECCIONAR SISTEMA PENSIONES --' : NombresisPensiones}}</option>
                  <option v-for="pensiones in sistemPension" :key="pensiones.id" :value="pensiones.parCorrelativo">
                    {{ pensiones.parDescripcion }} 
                  </option>
                </select>
              </div>
            </div>

            <div class="col col-lg-3 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-telephone fs-6 text-info me-2"></i>
              CONTACTO DE EMERGENCIA (APPELLIDOS Y NOMBRES):</label> 
              <input v-if="!apagar" type="text" class="form-control tamaños" v-model="guar.contacto"
                id="exampleInputEmail1"
                 />
            </div>

           <div class="col col-lg-3 col-sm-6">
            <label class="tamaño d-flex align-items-center gap-1">
              <i class="bi bi-phone fs-6 text-primary me-2"></i> N° DE CELULAR:</label>
              <input v-if="!apagar" type="text" class="form-control tamaños" v-model.trim="guar.celular"
                id="exampleInputEmail1" maxlength="9"
                aria-describedby="emailHelp" />
              <small v-if="guar.celular && guar.celular.length >= 9" class="text-danger d-block" style="font-size: 0.6rem;">
                ¡Límite de 9 caracteres alcanzado!
              </small>
            </div>

            <div class="col-lg-1 col-md-6 d-flex justify-content-end mt-4">
              <button v-if="permisoVisualizador == 2 || permisoVisualizador == 18" type="submit"
                class="btn btn-success mb-3 px-3 py-2">
                <i class="bi bi-floppy fs-5"></i>
              </button>

              <button v-if="permisoVisualizador == 11 && guar.modIngreso == false" type="submit"
                class="btn btn-success px-4 py-1 mt-1" :class="{ 'w-100': !isMobile, 'w-25': isMobile }">
                <i class="bi bi-floppy fs-5"></i>
              </button>
            </div>
            <div></div>
          </div>
        </div>
      </form>
      <p class="text-danger mx-3 mt-2" v-if="guar.bancoHaberes == '003' && (idEmpresa == 3 || idEmpresa == 4)">
        <span style="font-weight: 600">OTRAS BANCAS:</span>
        <span class="text-danger">
          Si tienes tu cuenta de haberes en otras bancas distintas al BCP/BBVA
          "podrías" recibir la transacción al día siguiente 1pm.
        </span>
      </p>

      <p class="mx-2 mt-2 mb-3 px-2 text-justify texto">
        En conformidad con lo dispuesto en la Resolución Ministerial N°
        242-2017-TR.<strong> DECLARO BAJO JURAMENTO</strong>, que mis datos
        personales registrados en el presente formulario son los correctos y
        validos. Realizo la presente declaración jurada manifestando que la
        información proporcionada es verdadera y autorizo la verificación de lo
        declarado. En caso de falsedad declaro haber incurrido en el
        <strong>delito contra la Fe Pública, falsificación de Documentos, (Articulo
          427° del Código Penal, en concordancia con el Articulo IV inciso 1.7)
          "Principio de Presunción de Veracidad" del título preliminar de la Ley
          de Procesamiento Administrativo General, Ley N°27444.</strong>
        Al <strong>GRABAR </strong> la información doy por aceptado los datos
        enviados.
      </p>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "SolimanologSeleccionEstadoEdit",

  data() {
    return {
      loadingImagen: false,
      previewUrl: null,
      idEmpresa: "",
      url: "https://apitopas.gruposolimano.com.pe/Documentos/FotosPostulante/",
      apagate: true,
      adjuntoNombre: "",
      nombreRecuperado: "",
      menor: "<",
      desDocumento: "",
      nomGenero: "",
      nomEstadoCivil: "",
      ubiDepartamento: "",
      ubiProvincia: "",
      ubiDistrito: "",
      nomPais: "",
      nomNacionalidad: "",
      apagar: true,
      desGradoAcademico: "",
      bancoCts: "",
      bancoHaberes: "",
      monCts: "",
      monHaberes: "",
      NombresisPensiones: "",
      muestra: true,

      form: {
        idPostulante: "",
        posTipDocumento: "",
        posNroDocumento: "",
        posUbigeo: "",
        posNombre: "",
        posMotBloqueo: null,
        posApePaterno: "",
        posApeMaterno: "",
        posFecNacimiento: "",
        posGenero: "",
        posEstCivil: "",
        posTelefono: "",
        posTelAdicional: "",
        posPais: "",
        posNacionalidad: "",
        posPerProfesional: "",
        posAdjunto: "",
        posEstado: "",
        posOcupacion: "",
        posCorreo: "",
        posCanHijos: "",
        posDireccion: "",
        posHijosMen: "",
        posGradoAcademico: "",
        posEstudios: "",
        // modIngreso:false,
        modPostulante: Boolean,
        posEstadoConvoca: "",
        posCombloqueo: "",
        posRentaQuinta: false,
        posPolo:"",
        posPantalon:"",
        posZapatos:"",
        PosImagen: ""

      },

      guar: {
        idIngreso: "",
        idSolxPostulante: "",
        bancoHaberes: "",
        monHaberes: "",
        bancoCts: "",
        monCts: "",
        sisPensiones: "",
        contacto: "",
        celular: "",
        modIngreso: Boolean,
      },

      isdisabled: true,
      desPolo:"",
      desPantalon:"",
      desCalzado:"",  
      sistemPension: [],
      bancoHaber: [],
      moneda: [],
      banCts: [],
      provincia: [],
      distrito: [],
      gradoAcademico: [],

      permisoVisualizador: null,
      isMobile: false,
      polos:[],
      pantalon:[],
      zapatos:[],

    };
  },

  mounted() {
    this.permisoVisualizador = localStorage.getItem("idPerfil");

    this.axios.get("ParametroData/Parametro/2535").then((r) => {
      this.sistemPension = r.data;
    });

    this.axios.get("ParametroData/Parametro/2475").then((r) => {
      this.gradoAcademico = r.data;
    });

    this.axios.get("ParametroData/Parametro/7320").then((r) => {
      this.bancoHaber = r.data;
    });

    this.axios.get("ParametroData/Parametro/7317").then((r) => {
      this.moneda = r.data;
    });

    this.axios.get("ParametroData/Parametro/7361").then((r) => {
      this.banCts = r.data;
    });

    this.axios.get("ParametroData/Parametro/8006").then((r) => {
    this.polos = r.data;
    });

    this.axios.get("ParametroData/Parametro/8013").then((r) => {
    this.pantalon = r.data;
    });

     this.axios.get("ParametroData/Parametro/8024").then((r) => {
    this.zapatos = r.data;
    });

    this.guar.idSolxPostulante = this.$route.params.use;

    this.axios
      .get("Contrato/ObtenerDatosContrato/" + this.$route.params.use)
      .then((r) => {
        console.log(r.data);
        this.idEmpresa = r.data[0].idEmpresa;
        this.form.idPostulante = r.data[0].idPostulante;
        this.form.posApePaterno = r.data[0].posApellidoPaterno;
        this.form.posApeMaterno = r.data[0].posApellidoMaterno;
        this.form.posNombre = r.data[0].posNombre;
        this.form.posCorreo = r.data[0].posCorreo;
        this.form.posTelefono = r.data[0].posTelefono;
        this.desDocumento = r.data[0].nombreDocumento;
        this.form.posTipDocumento = r.data[0].posTipDocumento;
        this.form.posGenero = r.data[0].posGenero;
        this.form.posNroDocumento = r.data[0].posNroDocumento;
        this.form.posDireccion = r.data[0].posDireccion;
        this.nomGenero = r.data[0].nomGenero;
        this.nomEstadoCivil = r.data[0].nomEstadoCivil;
        this.form.posEstCivil = r.data[0].posEstadoCivil;
        this.form.posEstado = r.data[0].posEstado;
        this.form.posPerProfesional = r.data[0].posPerProfesional;
        this.form.posTelAdicional = r.data[0].posTelAdicional;
        this.form.posFecNacimiento = r.data[0].posFechaNacimiento.slice(0, 10);
        this.form.posNacionalidad = r.data[0].posNacionalidad;
        this.form.posCanHijos = r.data[0].posCantidadHijos;
        this.form.posHijosMen = r.data[0].posHijosMenores;
        this.form.posEstudios = r.data[0].posEstudiosSuperiores;
        this.ubiDepartamento = r.data[0].ubiDepartamento;
        this.ubiProvincia = r.data[0].ubiProvincia;
        this.ubiDistrito = r.data[0].ubiDistrito;
        this.form.posUbigeo = r.data[0].posUbigeo;
        this.nomPais = r.data[0].nomPais;
        this.form.posAdjunto = r.data[0].posAdjunto;
        this.form.posPais = r.data[0].posPais;
        this.form.posEstadoConvoca = r.data[0].posEstadoConvo;
        this.form.posCombloqueo = r.data[0].posCombloqueo
        console.log('aqui esta' ,this.form.posCombloqueo);
        this.form.posOcupacion = r.data[0].posOcupacion;
        this.form.posMotBloqueo = r.data[0].posMotBloqueo;
        this.form.modPostulante = r.data[0].modPostulante;
        this.nomNacionalidad = r.data[0].nomNacionalidad;
        this.form.posGradoAcademico = r.data[0].gradoAcademico;
        this.desGradoAcademico = r.data[0].desGradoAcademico;
        this.bancoCts = r.data[0].bancoCts;
        this.bancoHaberes = r.data[0].bancoHaberes;
        this.monCts = r.data[0].monCts;
        this.monHaberes = r.data[0].monHaberes;
        this.NombresisPensiones = r.data[0].sisPensiones;
        console.log(this.NombresisPensiones);
        this.form.posRentaQuinta = r.data[0].posRentaQuinta
        this.form.posPolo = r.data[0].posPolo
        this.form.posPantalon = r.data[0].posPantalon
        this.form.posZapatos = r.data[0].posZapatos
        this.form.PosImagen = r.data[0].posImagen
        this.desPolo = r.data[0].desPolo
        this.desPantalon = r.data[0].desPantalon  
        this.desCalzado = r.data[0].desCalzado

        console.log(this.form);
        this.guar.idIngreso = r.data[0].idMaeIngreso;
        this.guar.bancoHaberes = r.data[0].codBancoHaberes;
        this.guar.monHaberes = r.data[0].codMonHaberes;
        this.guar.bancoCts = r.data[0].codBancoCts;
        this.guar.monCts = r.data[0].codMonCts;
        this.guar.sisPensiones = r.data[0].codSisPensiones;
        this.guar.contacto = r.data[0].nomConEmergencia;
        this.guar.celular = r.data[0].nroCelEmergencia;
        this.guar.modIngreso = r.data[0].modIngreso;
        
      });
  },

  computed: {
    ...mapGetters("parametros", [
      "EstadoCiviles",
      "Genero",
      "Arreglar",
      "DepartamentoDistrito",
      "NacionEstado",
      "PaisEstado",
    ]),
  },

  created() {
    this.cambiarEstadoNavbar();
  },

  methods: {
    ...mapActions("listadoPostulante", ["editar"]),

    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

    retrocedo() {
      window.history.back();
    },

    checkIfMobile() {
      this.isMobile = window.innerWidth <= 768; // Ajusta el ancho según tus necesidades
    },

    async modificaPostulante() {
      // if (this.permisoVisualizador == 11) {
      //   const fd = new FormData();

      //   fd.append("IdPostulante", this.form.idPostulante);
      //   fd.append("PosTipDocumento", this.form.posTipDocumento);
      //   fd.append("PosNroDocumento", this.form.posNroDocumento);
      //   fd.append("PosNombre", this.form.posNombre);
      //   fd.append("PosApePaterno", this.form.posApePaterno);
      //   fd.append("PosApeMaterno", this.form.posApeMaterno);
      //   fd.append("PosFecNacimiento", this.form.posFecNacimiento);
      //   fd.append("PosGenero", this.form.posGenero);
      //   fd.append("PosEstCivil", this.form.posEstCivil);
      //   fd.append("PosTelefono", this.form.posTelefono);
      //   fd.append("PosTelAdicional", this.form.posTelAdicional);
      //   fd.append("PosPais", this.form.posPais);
      //   fd.append("PosUbigeo", this.form.posUbigeo);
      //   fd.append("PosNacionalidad", this.form.posNacionalidad);
      //   fd.append("PosPerProfesional", this.form.posPerProfesional);
      //   fd.append("posMotBloqueo", this.form.posMotBloqueo);

      //   fd.append("PosEstado", this.form.posEstado);
      //   fd.append("PosOcupacion", this.form.posOcupacion);
      //   fd.append("PosCorreo", this.form.posCorreo);
      //   fd.append("PosCanHijos", this.form.posCanHijos);
      //   fd.append("PosDireccion", this.form.posDireccion);
      //   fd.append("PosHijosMen", this.form.posHijosMen);
      //   // fd.append("modIngreso", this.form.modIngreso);
      //   fd.append("PosGradoAcademico", this.form.posGradoAcademico);
      //   fd.append("PosEstudios", this.form.posEstudios);
      //   fd.append("PosAdjunto", this.form.posAdjunto);
      //   fd.append("ArchivoPos", this.form.posAdjunto);
      //   fd.append("posEstadoConvoca", this.form.posEstadoConvoca);

      //   fd.append("modPostulante", true);
      //   console.log(this.form);

      //   this.editar(fd);
      // }
      // else

      if (
        this.form.posCanHijos >= 0 &&
        this.form.posCanHijos < 10 &&
        this.form.posHijosMen >= 0 &&
        this.form.posHijosMen < 10
      ) {
        this.loadingImagen = true;
        console.log("se ejecuto otro");
        const fd = new FormData();
        console.log(this.form);

        fd.append("IdPostulante", this.form.idPostulante);
        fd.append("PosTipDocumento", this.form.posTipDocumento);
        fd.append("PosNroDocumento", this.form.posNroDocumento);
        fd.append("PosNombre", this.form.posNombre);
        fd.append("PosApePaterno", this.form.posApePaterno);
        fd.append("PosApeMaterno", this.form.posApeMaterno);
        fd.append("PosFecNacimiento", this.form.posFecNacimiento);
        fd.append("PosGenero", this.form.posGenero);
        fd.append("PosEstCivil", this.form.posEstCivil);
        fd.append("PosTelefono", this.form.posTelefono);
        fd.append("PosTelAdicional", this.form.posTelAdicional);
        fd.append("PosPais", this.form.posPais);
        fd.append("PosUbigeo", this.form.posUbigeo);
        fd.append("PosNacionalidad", this.form.posNacionalidad);
        fd.append("PosPerProfesional", this.form.posPerProfesional);
        fd.append("posMotBloqueo", this.form.posMotBloqueo);

        fd.append("PosEstado", this.form.posEstado);
        fd.append("PosOcupacion", this.form.posOcupacion);
        fd.append("PosCorreo", this.form.posCorreo);
        fd.append("PosCanHijos", this.form.posCanHijos);
        fd.append("PosDireccion", this.form.posDireccion);
        fd.append("PosHijosMen", this.form.posHijosMen);
        // fd.append("modIngreso", this.form.modIngreso);
        fd.append("PosGradoAcademico", this.form.posGradoAcademico);
        fd.append("PosEstudios", this.form.posEstudios);
        fd.append("PosAdjunto", this.form.posAdjunto);
        fd.append("ArchivoPos", this.form.posAdjunto);
        fd.append("modPostulante", this.form.modPostulante);
        fd.append("posEstadoConvoca", this.form.posEstadoConvoca);
        fd.append("posComBloqueo", this.form.posCombloqueo);
        fd.append("posRentaQuinta", this.form.posRentaQuinta);

        // --- LÓGICA PARA LA FOTO (IMAGEN) ---
          // Si es un archivo nuevo, lo enviamos en ImagenGuardada
          fd.append("ImagenGuardada", this.form.PosImagen);
          fd.append("PosImagen", this.form.PosImagen); // Enviamos vacío para que la API use la nueva ruta
       
      
        fd.append("posPolo", this.form.posPolo);
        fd.append("posPantalon", this.form.posPantalon);
        fd.append("posCalzado", this.form.posZapatos);

        try {
          await this.editar(fd);
          this.previewUrl = null; // Limpiar preview tras éxito
        } finally {
          this.loadingImagen = false;
        }
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Excediste la cant. de hijos o Mayores de 18 años",
          showConfirmButton: false,
          timer: 3500,
        });
      }
    },

    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.form.PosImagen = file; 
        
        // Crear previsualización local
        const reader = new FileReader();
        reader.onload = (e) => {
          this.previewUrl = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.previewUrl = null;
      }
    },

    onFileSelected(event) {
      this.form.posAdjunto = event.target.files[0];
      if (event.target.value != "") {
        this.adjuntoNombre = event.target.files[0].name;
        console.log(this.adjuntoNombre);
        this.apagate = false;
      } else {
        this.apagate = false;
        this.adjuntoNombre = this.nombreRecuperado;
        this.form.posAdjunto = this.nombreRecuperado;

        console.log(this.form.posAdjunto);
      }
    },

    activador() {
      this.isdisabled = !this.isdisabled;
      this.muestra = !this.muestra;
    },

    bancoHab(event) {
      this.guar.bancoHaberes = event.target.value;
    },

    moneda1(event) {
      this.guar.monHaberes = event.target.value;
    },
    bancoCts1(event) {
      this.guar.bancoCts = event.target.value;
    },
    monedaCts1(event) {
      this.guar.monCts = event.target.value;
    },
    pensiones1(event) {
      this.guar.sisPensiones = event.target.value;
    },
    estado(event) {
      this.form.posEstCivil = event.target.value;
      console.log(event.target.value);
    },
    Generos(event) {
      this.form.posGenero = event.target.value;
      console.log(event.target.value);
    },
    Documentos(event) {
      this.form.posTipDocumento = event.target.value;
      console.log(event.target.value);
    },

    Departamen(event) {
      console.log(event.target.value);
      this.axios
        .get(`ParametroData/Parametro/${event.target.value}`)
        .then((datos) => {
          console.log(datos.data);
          this.provincia = datos.data;
        });
    },

    Province(event) {
      this.axios
        .get(`DistritoData/Listar/${event.target.value}`)
        .then((datos) => {
          this.distrito = datos.data;
        });
    },

    Distrito(event) {
      this.form.posUbigeo = event.target.value;
      console.log(event.target.value);
    },
    PaisDes(event) {
      this.form.posPais = event.target.value;
    },

    Nacion(event) {
      this.form.posNacionalidad = event.target.value;
      console.log(event.target.value);
    },

    Grado(event) {
      this.form.posGradoAcademico = event.target.value;
    },

    cambiarBancos() {
      console.log(this.guar);

      if (this.permisoVisualizador == 11) {
        this.guar.modIngreso = true;
        this.axios.put("Postulante/ModificarBancos", this.guar).then((r) => {
          console.log(r.data);
          if (r.data == true) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Se Realizo los cambios",
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Se Realizo los cambios",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        });
      }

      if (this.permisoVisualizador != 11) {
        this.axios.put("Postulante/ModificarBancos", this.guar).then((r) => {
          console.log(r.data);
          if (r.data == true) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Se Realizo los cambios",
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Se Realizo los cambios",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        });
      }
      //
    },

    refrescarBancos() {
      const form = {
        PosNroDocumento: this.form.posNroDocumento,
        idSolxPostulante: `${this.$route.params.use}`,
      };
      console.log(form);
      this.axios.put("Postulante/ModificarIngreso", form).then((r) => {
        if (r.data == true) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Se Realizo los cambios",
            showConfirmButton: false,
            timer: 1500,
          });
        } else {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Se Realizo los cambios",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    },
  },
};
</script>

<style scoped>

.tituloColor {
  color: #0080c8;
  font-weight: 700;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  text-decoration: underline;
}

.bg-verde {
  background-color: rgb(19, 163, 38);
}

.tamaño {
  font-size: 0.65rem;

  font-weight: 800;
  color: #002c5d;
}

.tamaños {
  font-size: 0.65rem;
}

.bg-solimano {
  border-color: #0080c8;
  border-width: 2px;
}

input[type="text"],
input[type="textArea"],
textArea {
  text-transform: uppercase;
}

.texto {
  font-size: 0.65rem;
  padding: 0;
  margin: 0;
}

.text-justify {
  text-align: justify;
}

.tituloColorMas {
  /* color: #002c5d; */
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.image-upload-circle {
  border-radius: 50%;
  background-color: #f0f0f0;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  border: 3px dashed #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-upload-circle.large {
  width: 150px;
  height: 150px;
}

.image-upload-circle img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-upload-circle:hover {
  border-color: #999;
}

.upload-text {
  position: absolute;
  color: #666;
  font-size: 18px;
  text-align: center;
  pointer-events: none;
}
</style>
